import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

/** Themed replacement for `window.prompt` wherever a governance decision needs a
 * reason on the audit trail. Native prompts cannot be styled, cannot be
 * validated, and block the page — neither is acceptable for a decision that is
 * written into an audit log. */
export function ReasonDialog({
    open, title, description, label = "Reason", placeholder = "",
    confirmLabel = "Record decision", required = false, testId = "reason-dialog",
    onConfirm, onCancel,
}) {
    const [reason, setReason] = useState("");
    useEffect(() => { if (open) setReason(""); }, [open]);
    const blocked = required && !reason.trim();
    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onCancel?.(); }}>
            <DialogContent data-testid={testId} className="bg-[var(--bg-elevated)] border border-cyan-500/20 text-slate-200 max-w-lg">
                <DialogHeader>
                    <DialogTitle className="font-display text-white">{title}</DialogTitle>
                    <DialogDescription className="text-xs text-slate-500 font-mono">{description}</DialogDescription>
                </DialogHeader>
                <div className="space-y-1.5">
                    <label htmlFor={`${testId}-input`} className="text-[10px] font-mono uppercase tracking-wider text-slate-400">
                        {label}{required ? " (required)" : " (optional)"}
                    </label>
                    <textarea
                        id={`${testId}-input`}
                        data-testid={`${testId}-input`}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        rows={3}
                        placeholder={placeholder}
                        autoFocus
                        className="field w-full text-xs resize-y"
                    />
                </div>
                <DialogFooter>
                    <button data-testid={`${testId}-cancel`} onClick={() => onCancel?.()} className="btn-ghost text-xs">
                        Cancel
                    </button>
                    <button
                        data-testid={`${testId}-confirm`}
                        onClick={() => onConfirm?.(reason.trim())}
                        disabled={blocked}
                        className="btn-primary text-xs disabled:opacity-50"
                    >
                        {confirmLabel}
                    </button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
